import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { BackendResponse } from '../../shared/backend-response.model';

@Component({
    selector: 'app-activate-user',
    templateUrl: './activate-user.component.html',
    styleUrls: ['./activate-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActivateUserComponent extends ComponentView {

    neededParams: ObjectOfSimpleDataTypes = { key: "string" };
    key = "";

    running = true;
    resultType: "success" | "error";
    resultMessage = "";

    async initParams(): Promise<boolean> {
        try {
            await RestEndpoint.main().query({key: this.key}).post().run("api/app/auth/activate").get(BackendResponse);
            this.resultType = "success";
            this.resultMessage = "Die Aktivierung war erfolgreich";
            this.running = false;
        }
        catch (ex) {
            this.resultType = "error";
            this.resultMessage = "Die Aktivierung war nicht erfolgreich. " + BackendResponse.getFromException(ex).items[0].message;
            this.running = false;
        }
        return true;
    }

}
